import {Component, Inject} from '@angular/core';
import {ImageCroppedEvent, OutputFormat} from "ngx-image-cropper";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {closeCroppedImageWithWhiteBackground} from "../utils/image.utils";

@Component({
  selector: 'app-image-cropper',
  templateUrl: './cover-image-cropper-dialog.component.html',
  styleUrls: ['../profile-image-cropper-dialog/profile-image-cropper-dialog.component.scss', './cover-image-cropper-dialog.component.scss']
})
export class CoverImageCropperDialogComponent {

  imageChangedEvent: Event | null = null;
  croppedImage: Blob | null = null;
  sizeToWidth: number = 800;
  sizeToHeight: number = 400;
  ratio: number = 16 / 5;
  imageQuality: number = 100;
  outputFormat: OutputFormat = 'png';

  constructor(
    private dialogRef: MatDialogRef<CoverImageCropperDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.imageChangedEvent = data.imageChangedEvent;
  }

  imageCropped(event: ImageCroppedEvent) {
    if (event && event.blob) {
      this.croppedImage = event.blob;
    } else {
      console.error('No blob data found in cropped event:', event);
    }
  }

  async onCrop() {
    await closeCroppedImageWithWhiteBackground(this.dialogRef, this.croppedImage);
  }

  onCancel() {
    this.dialogRef.close(null);
  }

}
